import { render } from "./InformationPopup.vue?vue&type=template&id=784a9f5e&scoped=true&ts=true"
import script from "./InformationPopup.vue?vue&type=script&lang=ts"
export * from "./InformationPopup.vue?vue&type=script&lang=ts"

import "./InformationPopup.vue?vue&type=style&index=0&id=784a9f5e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784a9f5e"]])

export default __exports__